import React, { forwardRef, useCallback, useMemo } from 'react';
import WithContextMenu from '@polestar/component-warehouse-react/components/with-context-menu/WithContextMenu';
import { useSnackbar } from '@polestar/component-warehouse-react/components/snackbar/SnackbarContext';
export var ShareDialogServices;
(function (ShareDialogServices) {
    ShareDialogServices["twitter"] = "twitter";
    ShareDialogServices["facebook"] = "facebook";
    ShareDialogServices["linkedIn"] = "linkedIn";
    ShareDialogServices["email"] = "email";
    ShareDialogServices["copy"] = "copy";
    ShareDialogServices["custom"] = "custom";
})(ShareDialogServices || (ShareDialogServices = {}));
const defaultServiceProps = {
    [ShareDialogServices.twitter]: {
        label: 'Twitter',
        generateShareData: ({ url }) => `https://twitter.com/intent/tweet?url=${url}`,
    },
    [ShareDialogServices.facebook]: {
        label: 'Facebook',
        generateShareData: ({ url }) => `https://www.facebook.com/sharer.php?u=${url}`,
    },
    [ShareDialogServices.linkedIn]: {
        label: 'LinkedIn',
        generateShareData: ({ url }) => `https://www.linkedin.com/shareArticle?mini=true&url=${url}`,
    },
    [ShareDialogServices.email]: {
        generateShareData: ({ url }) => `mailto:?body=${url}`,
    },
    [ShareDialogServices.copy]: {
        generateShareData: ({ url }) => url,
    },
};
const WithShareDialog = forwardRef(({ url, items, ...props }, ref) => {
    const { addSnackbar } = useSnackbar();
    const handleShare = useCallback((urlGenerate, serviceType, { successMessage, failedMessage } = {}) => {
        return () => {
            const internalUrl = url || window.location.href;
            const serviceUrl = urlGenerate({ url: internalUrl });
            if (serviceType === ShareDialogServices.copy) {
                navigator.clipboard.writeText(serviceUrl).then(() => {
                    if (successMessage) {
                        addSnackbar({
                            content: successMessage,
                            closeOnClick: true,
                        });
                    }
                }, () => {
                    if (failedMessage) {
                        addSnackbar({
                            content: failedMessage,
                            error: true,
                            closeOnClick: true,
                        });
                    }
                });
            }
            else if (serviceType === ShareDialogServices.email) {
                document.location = serviceUrl;
            }
            // Share via popup
            else {
                window.open(serviceUrl, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
            }
        };
    }, [addSnackbar, url]);
    const combinedItems = useMemo(() => [
        ...items.map(({ 
        // @ts-ignore
        generateShareData, 
        // @ts-ignore
        successMessage, 
        // @ts-ignore
        failedMessage, label, serviceType = ShareDialogServices.custom, ...item }) => {
            const serviceData = defaultServiceProps === null || defaultServiceProps === void 0 ? void 0 : defaultServiceProps[serviceType];
            // @ts-ignore
            const generateUrl = generateShareData || (serviceData === null || serviceData === void 0 ? void 0 : serviceData.generateShareData);
            return {
                ...item,
                type: serviceType,
                label: label || (serviceData === null || serviceData === void 0 ? void 0 : serviceData.label) || serviceType,
                onClick: generateUrl
                    ? handleShare(generateUrl, serviceType, { successMessage, failedMessage })
                    : item.onClick,
            };
        }),
    ], [handleShare, items]);
    // @ts-ignore
    return React.createElement(WithContextMenu, { ...props, items: combinedItems, ref: ref });
});
WithShareDialog.displayName = 'WithShareDialog';
export default WithShareDialog;
